import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import Graphs from "./Tables/Graphs";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    flexWrap: "wrap",  // ✅ allows two columns to wrap
    padding: 20,
  },
  description: {
    width: "100%",
    fontSize: 8,
    marginBottom: 12,
    paddingHorizontal: 20,
    lineHeight: 1.5,
  },  
  chartWrapper: {
    width: "45%",      // ✅ two per row (with a little spacing)
    marginBottom: 10, 
  },
  chart: {
    width: "100%",
    objectFit: "contain",
  },
});

export const Pdf = ({ chartImage, description }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* ✅ Description text at the top */}
      <View style={{ width: "100%" }}>
        <Text style={styles.description}>{description}</Text>
      </View>

      {/* ✅ Charts below */}
      {chartImage.map((img, i) => (
        <View key={i} style={styles.chartWrapper}>
          <Image src={img} style={styles.chart} />
        </View>
      ))}
    </Page>
  </Document>
);

export function DownloadInvoiceButton({ chartImage, description }) {

  const allImagesReady = chartImage && chartImage.length > 0 && chartImage.every(img => img);

  return (
<button
  disabled={!allImagesReady}
  style={{
    padding: "8px 16px",
    marginLeft: 10,
    background: allImagesReady ? "#464f62" : "#999",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    cursor: allImagesReady ? "pointer" : "not-allowed",
  }}
>
  {allImagesReady ? (
    <PDFDownloadLink
      document={<Pdf chartImage={chartImage} description={description} />}
      fileName="Summary.pdf"
      style={{ color: "#fff", textDecoration: "none" }}
    >
      Download PDF
    </PDFDownloadLink>
  ) : (
    "Preparing..."
  )}
</button>

  );
}